import { useEffect, useRef } from "react";

import useAdminParams from "hooks/useAdminParams";
import { useAdmin } from "providers/AdminProvider/AdminProvider";
import isValidId from "functions/isValidId";

/**
 * This is a quick-and-dirty wrapper which closes open User and Licence tabs
 * when a different portal is opened
 * @param children
 * @returns {*}
 * @constructor
 */
const TabCleanser = ({ children }) => {
  const openPortal = useRef();

  const { portalId } = useAdminParams();
  const { setOpenUsers, setOpenLicences } = useAdmin();

  useEffect(() => {
    if (isValidId(portalId)) {
      if (portalId !== openPortal.current) {
        setOpenUsers([]);
        setOpenLicences([]);
        openPortal.current = portalId;
      }
    }
  }, [portalId, setOpenLicences, setOpenUsers]);

  return children;
};

export default TabCleanser;
